import {Box} from "@mui/material";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {QRCodeSVG} from "qrcode.react";

const ExpandQRCodeDialog = (props) => {
    const {open, setOpen, data} = props;
    
    const handleClose = () => {
        setOpen(false);
    }

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={handleClose}
                title="Gate Pass QR Code"
                subtitle={""}
                hasDividers={false}
                content={
                    <Box sx={{p: "10px 24px 32px"}}>
                        <QRCodeSVG 
                            value={data} 
                            style={{width: "100%", height: "100%"}} 
                        />
                    </Box>
                }
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default ExpandQRCodeDialog
